export const informCenter = {
    path: '/informCenter',
    name: 'informCenter',
    title: '站内消息',
    component: () => import("../components/page/homePage/informCenter"),
    meta:{title:'站内消息'},
}


// WEBPACK FOOTER //
// ./src/router/informCenter.js